import { TYPES } from '../../common/constants';
import * as client from '../../services/client';
import 'react-toastify/dist/ReactToastify.css';

export const setEasyWalkThroughFormData = (payload) => ({
  type: TYPES.SET_EASY_WALK_THROUGH_FORM_DATA,
  payload,
});

export const exitEasyWalkThroughForm = () => ({
  type: TYPES.EXIT_EASY_WALK_THROUGH_FORM,
});

export const fetchWalkThroughServiceList = (WalkthroughId) => (dispatch) => {
  return client.fetchWalkThroughServiceList(WalkthroughId).then((response) => {
    if (response.status === 200 || response.ok) {
      response.json().then((responsejson) => {
        dispatch(
          setEasyWalkThroughFormData({
            walkThroughServiceRequestListLoading: false,
            reviewWalkThroughServiceRequestListLoading: false,
            walkThroughServiceRequests: responsejson.serviceRequests,
            walkThroughSignatureList: responsejson.walkThroughSignatureList,
            walkthroughChecklistItems: responsejson.walkthroughChecklistItems,
            areaChecklist: responsejson.areaChecklist,
            notes: responsejson.notes ? responsejson.notes : '',
          })
        );
      });
    }
  });
};

export const downloadPDF = (walkthroughId) => (dispatch) => {
  return client.downloadPDF(walkthroughId).then((response) => {
    if (response.status === 200 || response.ok) {
      if (response.status === 204) {
      } else {
        response.json().then((responsejson) => {
          dispatch(
            setEasyWalkThroughFormData({
              PDFURL: responsejson,
            })
          );
        });
      }
    }
  });
};
